import {
  REPORTS_TRANSACTIONS_PAGE_REQUEST,
  REPORTS_TRANSACTIONS_ON_SEARCH,
  REPORTS_TRANSACTIONS_ON_REACH_BOTTOM,
  REPORTS_TRANSACTIONS_SET_ORDERS_BY_DATE,
  REPORTS_TRANSACTIONS_SET_ORDER_SUMMARY,
  REPORTS_TRANSACTIONS_SET_NEXT_CURSOR,
  REPORTS_TRANSACTIONS_SET_HAS_MORE,
  REPORTS_TRANSACTIONS_SET_OUTLET_BY_ID,
  REPORTS_TRANSACTIONS_SET_PAYMENT_METHODS,
  REPORTS_TRANSACTIONS_GET_ORDER_DETAIL,
  REPORTS_TRANSACTIONS_SET_ORDER_DETAIL,
  REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
  REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
} from './constants';

export function pageRequest() {
  return {
    type: REPORTS_TRANSACTIONS_PAGE_REQUEST,
    payload: {},
  };
}

export function onSearch(searchValues) {
  return {
    type: REPORTS_TRANSACTIONS_ON_SEARCH,
    payload: { searchValues },
  };
}

export function onReachBottom(searchValues) {
  return {
    type: REPORTS_TRANSACTIONS_ON_REACH_BOTTOM,
    payload: { searchValues },
  };
}

export function setOrdersByDate(ordersByDate) {
  return {
    type: REPORTS_TRANSACTIONS_SET_ORDERS_BY_DATE,
    payload: { ordersByDate },
  };
}

export function setOrderSummary(orderSummary) {
  return {
    type: REPORTS_TRANSACTIONS_SET_ORDER_SUMMARY,
    payload: { orderSummary },
  };
}

export function setNextCursor(nextCursor) {
  return {
    type: REPORTS_TRANSACTIONS_SET_NEXT_CURSOR,
    payload: { nextCursor },
  };
}

export function setHasMore(hasMore) {
  return {
    type: REPORTS_TRANSACTIONS_SET_HAS_MORE,
    payload: { hasMore },
  };
}

export function setOutletById(outletById) {
  return {
    type: REPORTS_TRANSACTIONS_SET_OUTLET_BY_ID,
    payload: { outletById },
  };
}

export function setPaymentMethods(paymentMethods) {
  return {
    type: REPORTS_TRANSACTIONS_SET_PAYMENT_METHODS,
    payload: { paymentMethods },
  };
}

export function getOrderDetail(id, isMobile) {
  return {
    type: REPORTS_TRANSACTIONS_GET_ORDER_DETAIL,
    payload: { id, isMobile },
  };
}

export function setOrderDetail(orderDetail) {
  return {
    type: REPORTS_TRANSACTIONS_SET_ORDER_DETAIL,
    payload: { orderDetail },
  };
}

export function issueRefundRequest(data) {
  return { type: REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST, payload: { data } };
}

export function setRefundItems(items) {
  return {
    type: REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
    payload: { items },
  };
}

export function setRefundItemsPromo(itemsPromo) {
  return {
    type: REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
    payload: { itemsPromo },
  };
}

export function confirmSetQuantity(refundItems) {
  return {
    type: REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
    payload: { refundItems },
  };
}
